/* eslint-disable import/no-extraneous-dependencies */
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.LaravelEcho = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: false,
    encrypted: process.env.MIX_PUSHER_SCHEME === 'https',
    enableLogging: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
});
